// english
export default {
  // 登录模块
  login_btn: 'Login',
  login_description:
    '(MBE) is a remote management platform, which provides remote monitoring, remote debugging, remote diagnosis and other device-maintenance related functions.',
  login_forgot_link_text: 'Forgot My Password ?',

  login_form_username_placeholder: 'Username',
  login_form_username_required_msg: 'Username cannot be empty',
  login_form_captcha_placeholder: 'Captcha',
  login_form_captcha_required_msg: 'Captcha cannot be empty',
  login_form_password_placeholder: 'Password',
  login_form_password_required_msg: 'Password cannot be empty',

  login_form_error_userinfo: 'Failed to obtain user information, please refresh and try',
  login_copyright: '',
};
